import { render, staticRenderFns } from "./WorkspaceCard.vue?vue&type=template&id=4af4fd5e"
import script from "./WorkspaceCard.vue?vue&type=script&lang=js"
export * from "./WorkspaceCard.vue?vue&type=script&lang=js"
import style0 from "./WorkspaceCard.vue?vue&type=style&index=0&id=4af4fd5e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports